module.exports = __webpack_public_path__ + "static/vitalsigns-b89dfa3ca5a102a18262667e44dfe1ed.png";